import styled from "styled-components";

const Main = styled.main`
    flex: 1;
    margin-top: 3rem;
`;

export default Main;
